export default __webpack_public_path__ + "static/media/trophe.6822ebc9.svg";